// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 1H4V23H20V1ZM13.0039 17V19.0039H11V17H13.0039Z"}}]};

const MobileFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-filled',
    ref,
    icon: element,
  },
));

MobileFilledIcon.displayName = 'MobileFilledIcon';

export default MobileFilledIcon;
